if (typeof FullCalendarVDom === 'undefined') {
  throw new Error('Please import the top-level fullcalendar lib before attempting to import a plugin.');
}

export var Component = FullCalendarVDom.Component;
export var createElement = FullCalendarVDom.createElement;
export var render = FullCalendarVDom.render;
export var createRef = FullCalendarVDom.createRef;
export var Fragment = FullCalendarVDom.Fragment;
export var createContext = FullCalendarVDom.createContext;
export var flushToDom = FullCalendarVDom.flushToDom;